import React from 'react';
import { SparkleIcon } from '@phosphor-icons/react';
import { LoaderFive } from '../components/ui/loader';

const LoadingState = () => {
  return (
    <div className="flex items-center justify-center w-[442px]">
      {/* Main Modal */}
      <div
        className="relative text-center py-8 px-8 rounded-[24px] border-[2px] border-[var(--q3-surface-default)]"
        style={{
          background:
            'radial-gradient(77.45% 50.52% at 21.12% 50%, var(--q3-surface-default) 35.97%, var(--q3-accent-light) 100%)',
        }}
      >
        {/* Replaced static text with LoaderFive */}
        <div className="flex items-center justify-center gap-2">
          <SparkleIcon size={24} weight="fill" style={{ fill: 'url(#sparkle-gradient)' }} />
          <LoaderFive text="Generating Qs....." />
        </div>

        <p className="text-[var(--q3-neutral-default)] text-sm mt-5">
          Please wait while Quizrr AI is generating Similar Questions for You!
        </p>

        {/* SVG Gradient Defs for Icon */}
        <svg width="0" height="0">
          <linearGradient id="sparkle-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="var(--q3-violet-normal)" />
            <stop offset="100%" stopColor="var(--q3-rose-normal)" />
          </linearGradient>
        </svg>
      </div>
    </div>
  );
};

export default LoadingState;
